// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"309":"e42466f5","987":"f7d72a86"}[chunkId] + ".chunk.js";
};